import axios from 'axios';

const API_BASE =
  process.env.REACT_APP_PLANIFICATION_API_URL || 'http://localhost:4000/api/planification';
const API_KEY = process.env.REACT_APP_PLANIFICATION_API_KEY || '';

export const PLANIFICATION_MONTHS = [
  'mai',
  'juin',
  'juillet',
  'aout',
  'septembre',
  'octobre',
  'novembre',
  'decembre',
  'janvier',
  'fevrier',
  'mars',
  'avril',
];

const withApiKey = (config = {}, includeSource = false) => {
  const headers = {
    ...(config.headers || {}),
  };

  if (API_KEY) {
    headers['x-api-key'] = API_KEY;
  }

  if (includeSource) {
    headers['x-source'] = 'producteur';
  }

  return {
    ...config,
    headers,
  };
};

/**
 * Normalise la réponse de l'API
 * Format API: { quantites: { mois: { planifId, mois, quantite } } }
 * Format normalisé: { quantites: { mois: quantite } } pour compatibilité formulaire
 */
const normalizeRecord = (record) => {
  if (!record) return null;

  // Extrait les quantités simples (mois → nombre)
  const quantites = {};
  if (record.quantites) {
    for (const [mois, data] of Object.entries(record.quantites)) {
      quantites[mois] = typeof data === 'object' ? data.quantite : data;
    }
  }

  return {
    producteurId: record.producteurId,
    legumeId: record.legumeId,
    surface: record.surface ?? '',
    certificat: record.certificat ?? '',
    quantites,
    raw: record,
  };
};

export const planificationApi = {
  /**
   * Récupère une planification par producteur/légume
   */
  async fetch({ producteurId, legumeId }) {
    if (!producteurId || !legumeId) {
      return null;
    }

    try {
      const encodedLegumeId = encodeURIComponent(legumeId);
      const { data } = await axios.get(
        `${API_BASE}/producteur/${producteurId}/legume/${encodedLegumeId}`,
        withApiKey(),
      );
      return normalizeRecord(data);
    } catch (error) {
      if (error?.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  /**
   * Liste toutes les planifications d'un producteur
   */
  async listByProducteur(producteurId) {
    if (!producteurId) {
      return [];
    }

    const { data } = await axios.get(
      `${API_BASE}/producteur/${producteurId}`,
      withApiKey(),
    );
    return data.map(normalizeRecord);
  },

  /**
   * Sauvegarde une planification (create/update batch)
   */
  async save({ producteurId, legumeId, surface, certificat, quantites }) {
    const encodedLegumeId = encodeURIComponent(legumeId);
    const { data } = await axios.post(
      `${API_BASE}/producteur/${producteurId}/legume/${encodedLegumeId}`,
      { surface, certificat, quantites },
      withApiKey({}, true),
    );
    return normalizeRecord(data);
  },

  /**
   * Supprime toute la planification d'un producteur/légume
   */
  async remove({ producteurId, legumeId }) {
    const encodedLegumeId = encodeURIComponent(legumeId);
    await axios.delete(
      `${API_BASE}/producteur/${producteurId}/legume/${encodedLegumeId}`,
      withApiKey(),
    );
  },
};
